module.exports = __webpack_public_path__ + "img/13-ui-download-page-mockup.fa60d271.webp";